import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarFive: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M21.7 22.827c0-.453-.382-.82-.852-.82h-.681c-.47 0-.852.367-.852.82v.374c0 .453.381.821.852.821h.681c.47 0 .852-.367.852-.82v-.375z"
      clipRule="evenodd"
    />
    <path
      fill={color}
      d="M15.143 8.843c0-.454.381-.821.851-.821h2.598c.47 0 .851.367.851.82v.616c0 .453.381.82.852.82h.553c.47 0 .852.368.852.822v5.46c0 .454.38.822.851.822h2.598c.47 0 .851.367.851.82v.657c0 .453-.381.82-.852.82h-2.597c-.47 0-.851.889-.851 1.342v1.715h-2.385v-1.715c0-.453-.38-1.341-.851-1.341h-2.597c-.47 0-.852-.368-.852-.821v-.657c0-.453.381-.82.851-.82h2.598c.47 0 .851-.368.851-.821v-5.42c0-.454-.38-.821-.851-.821h-2.47c-.47 0-.851-.368-.851-.82v-.657z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M10.3 22.827c0-.453.382-.82.852-.82h.681c.47 0 .852.367.852.82v.374c0 .453-.382.821-.852.821h-.681c-.47 0-.852-.367-.852-.82v-.375z"
      clipRule="evenodd"
    />
    <path
      fill={color}
      d="M16.857 8.843c0-.454-.381-.821-.851-.821h-2.598c-.47 0-.851.367-.851.82v.616c0 .453-.381.82-.852.82h-.553c-.47 0-.852.368-.852.822v5.46c0 .454-.38.822-.851.822H6.852c-.47 0-.852.367-.852.82v.657c0 .453.381.82.852.82h2.597c.47 0 .851.889.851 1.342v1.715h2.385v-1.715c0-.453.38-1.341.851-1.341h2.598c.47 0 .851-.368.851-.821v-.657c0-.453-.381-.82-.851-.82h-2.598c-.47 0-.851-.368-.851-.821v-5.42c0-.454.38-.821.851-.821h2.47c.47 0 .851-.368.851-.82v-.657z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M13.101 14.032c0 .453.382.82.852.82h.681c.47 0 .852-.367.852-.82v-.698c0-.453-.382-.82-.852-.82h-.681c-.47 0-.852.367-.852.82v.698zM16.469 14.032c0 .453.381.82.852.82H18c.471 0 .852-.367.852-.82v-.698c0-.453-.38-.82-.851-.82h-.681c-.47 0-.852.367-.852.82v.698z"
      clipRule="evenodd"
    />
  </svg>
);

export default AvatarFive;
